import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const ADDRESS = "Rua Wenceslau Veiga, 01, Valéria, Salvador - BA";
const MAP_SRC = `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`;
const MAP_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;

export function Footer() {
  return (
    <footer className="mt-24 bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="cmyk-bar" />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:grid-cols-4 lg:px-8">
        <div className="space-y-3">
          <Logo dark />
          <p className="max-w-xs text-sm text-slate-400">Impressão digital e comunicação visual sob medida. Calcule, compre e acompanhe seu pedido online.</p>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-display font-semibold text-white">Navegação</p>
          <Link to="/" className="block hover:text-white" data-testid="footer-products">Produtos</Link>
          <Link to="/rastrear" className="block hover:text-white" data-testid="footer-track">Rastrear pedido</Link>
          <Link to="/conta" className="block hover:text-white" data-testid="footer-account">Minha conta</Link>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-display font-semibold text-white">Contato</p>
          <a href="tel:+5571993759996" className="block text-slate-400 hover:text-white" data-testid="footer-phone">(71) 99375-9996</a>
          <p className="text-slate-400" data-testid="footer-address">Rua Wenceslau Veiga, 01, Valéria<br />Salvador - BA</p>
          <div className="text-slate-400" data-testid="footer-hours">
            <p className="font-semibold text-slate-300">Horário de funcionamento</p>
            <p>Segunda a sexta: 8h às 18h</p>
            <p>Sábado: 8h às 12h</p>
          </div>
          <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" className="inline-block font-semibold text-[#38bdf8] hover:text-white" data-testid="footer-map-link">Como chegar</a>
        </div>
        <div className="overflow-hidden rounded-md border border-slate-700 md:col-span-3 lg:col-span-1" data-testid="footer-map">
          <iframe title="Localização da Sanvalle Gráfica" src={MAP_SRC} className="h-48 w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>
      </div>
      <p className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">© 2026 Sanvalle Gráfica</p>
    </footer>
  );
}
